module.exports = __webpack_public_path__ + "static/media/unlockBlue.d51e779f.svg";